import api from './api'

export interface Channel {
  id: number
  user_id: number
  telegram_id: number
  title: string
  username: string | null
  channel_type: string | null  // "channel" or "group"
  members_count: number | null
  description: string | null
  linked_chat_id: number | null
  status: string
  added_at: string | null
  last_parsed_at: string | null
  parsing_interval: number
  auto_parse_enabled: boolean
}

export interface ChannelCreate {
  username: string
  keywords?: string[]
}

export interface ChannelUpdate {
  is_active?: boolean
  parsing_interval?: number
  auto_parse_enabled?: boolean
}

export interface ChannelParsingStatus {
  id: number
  title: string
  auto_parse_enabled: boolean
  parsing_interval: number
  last_parsed_at: string | null
  next_parse_at: string | null
  status: string
}

export interface ChannelDiscovery {
  telegram_channel_id: number
  title: string
  username: string | null
  member_count: number | null
  channel_type: string | null
  relevance_score: number
  description: string | null
}

export interface ChannelStats {
  total_channels: number
  active_channels: number
  total_leads: number
  leads_today: number
}

export const channelsService = {
  async getChannels(): Promise<Channel[]> {
    const response = await api.get<Channel[]>('/channels')
    return response.data
  },

  async getChannel(channelId: number): Promise<Channel> {
    const response = await api.get<Channel>(`/channels/${channelId}`)
    return response.data
  },

  async addChannel(data: ChannelCreate): Promise<Channel> {
    const response = await api.post<Channel>('/channels', data)
    return response.data
  },

  async updateChannel(channelId: number, data: ChannelUpdate): Promise<Channel> {
    const response = await api.patch<Channel>(`/channels/${channelId}`, data)
    return response.data
  },

  async deleteChannel(channelId: number): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/channels/${channelId}`)
    return response.data
  },

  async getStats(): Promise<ChannelStats> {
    const response = await api.get<ChannelStats>('/channels/stats')
    return response.data
  },

  async discoverChannels(query: string, minSubscribers: number = 0): Promise<ChannelDiscovery[]> {
    const response = await api.get<ChannelDiscovery[]>('/channels/discover', {
      params: { query, min_subscribers: minSubscribers || undefined },
    })
    return response.data
  },

  async bulkAddChannels(handles: string[]): Promise<{ added: any[]; failed: any[] }> {
    const response = await api.post<{ added: any[]; failed: any[] }>('/channels/bulk', handles)
    return response.data
  },

  async parseChannel(channelId: number): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(`/channels/${channelId}/parse`)
    return response.data
  },

  async getParsingStatus(): Promise<ChannelParsingStatus[]> {
    const response = await api.get<ChannelParsingStatus[]>('/channels/parsing-status')
    return response.data
  },
}
